module.exports = __webpack_public_path__ + "static/img/return_bad_example_2.242044e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/return_bad_example_2.jpg
// module id = hOFq
// module chunks = 1